module.exports = __webpack_public_path__ + "static/media/2006-dan.930b5845.jpg";